export default __webpack_public_path__ + "static/media/ib.3ca3814c.svg";